<template>
    <div>
        <el-dialog
            :visible.sync="dialogFormVisible"
            :append-to-body="true"
            width="70%"
            :center="true"
            top="5vh"
            :close-on-click-modal="false"
            :before-close="() => closePettyDialog('PettyEditForm')"
            v-loading.fullscreen.lock="login_loading"
        >
            <template #title>
                <span style="font-weight: bold;">{{dialogFormTitle}}</span>
                <el-tag v-if="petty.state===0" type="info" size="mini">待提交</el-tag>
                <el-tag v-if="petty.state===1" size="mini">审批中</el-tag>
                <el-tag v-if="petty.state===2" type="success" size="mini">已通过</el-tag>
                <el-tag v-if="petty.state===3" type="danger" size="mini">已驳回</el-tag>
                <el-button
                    v-if="(petty.state>0) && ($_has(print_auth))"
                    plain
                    circle
                    icon="el-icon-printer"
                    @click="clk_print()"
                    ></el-button
                >
            </template>
            <div>
                <el-form
                    :model="petty"
                    :rules="rules"
                    ref="PettyEditForm"
                    label-width="100px"
                    size="small"
                >
                    <div v-if="show_type">
                        <fieldset  class="fieldsetc">
                            <legend class="legendc">基础信息</legend>
                            <el-form-item label="申请部门" prop="department_id">
                                <el-cascader
                                    v-model="petty.department_id"
                                    :options="enterprise_department"
                                    :props="{ expandTrigger: 'hover' }"
                                    clearable
                                    style="width: 100%"
                                >
                                </el-cascader>
                            </el-form-item>
                            <el-form-item  label="备用金类型" prop="type">
                                <el-select
                                    v-model="petty.type"
                                    filterable
                                    clearable
                                    placeholder="选择类型"
                                    class="typec"
                                >
                                    <el-option
                                        v-for="(v,i) in all_type"
                                        :key="v"
                                        :label="v"
                                        :value="i"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </fieldset>
                        <fieldset  class="fieldsetc">
                            <legend class="legendc">借支信息</legend>
                            <el-form-item label="借支标题" prop="title">
                                <el-input v-model="petty.title" clearable ></el-input>
                            </el-form-item>
                            <el-form-item label="申请原由" prop="content">
                                <el-input type="textarea" :rows="5" v-model="petty.content"></el-input>
                            </el-form-item>
                            <el-form-item label="申请金额" prop="money">
                                <el-input-number
                                    v-model="petty.money"
                                    :min="0"
                                    :step="1"
                                    :precision="2"
                                    :step-strictly="false"
                                    size="small"
                                    class="input_number"
                                ></el-input-number>
                            </el-form-item>
                        </fieldset>
                        <fieldset  class="fieldsetc bottomc">
                            <legend class="legendc">账户信息</legend>
                            <el-form-item  label="汇款方式" prop="pay_way">
                                <el-select
                                    v-model="petty.pay_way"
                                    filterable
                                    clearable
                                    placeholder="选择汇款方式"
                                    class="pay_wayc"
                                >
                                    <el-option
                                        v-for="(v,i) in all_pay_way"
                                        :key="v"
                                        :label="v"
                                        :value="i"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="选择银行卡" prop="with_bank_card">
                                <el-select
                                    v-model="petty.with_bank_card"
                                    filterable
                                    clearable
                                    placeholder="选择银行卡"
                                    @change="(e) => cardChange(e)"
                                    class="with_bank_cardc"
                                >
                                    <el-option
                                        v-for="item in Allcard"
                                        :key="item.card"
                                        :label="'【'+item.user_name+'】'+item.card+' — '+item.bank"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="卡号">
                                <span>{{petty.account_card}}</span>
                            </el-form-item>
                            <el-form-item label="户主">
                                <span>{{petty.account_name}}</span>
                            </el-form-item>
                            <el-form-item label="开户行">
                                <span>{{petty.account_bank}}</span>
                            </el-form-item>
                        </fieldset>
                        <common-upload-component
                            ref="upload"
                            :ffileList="petty.other"
                            upload_url="petty/upload"
                        ></common-upload-component>
                    </div>
                    <div v-else>
                        <fieldset  class="fieldsetc">
                            <legend class="legendc">基础信息</legend>
                            <el-descriptions
                                class="margin-top"
                                :column="2"
                                :labelStyle="{'width':'120px','text-align':'center'}"
                                :contentStyle="{'text-align': 'center'}"
                                border
                            >
                                <el-descriptions-item>
                                    <template slot="label">
                                        <span>申请部门</span>
                                    </template>
                                    <span>{{petty.enterprise_name ? petty.enterprise_name + '/' + petty.department_name : ''}}</span>
                                </el-descriptions-item>
                                <el-descriptions-item>
                                    <template slot="label">
                                        <span>申请人</span>
                                    </template>
                                    <span>{{petty.staff_name}}</span>
                                </el-descriptions-item>
                            </el-descriptions>
                        </fieldset>
                        <fieldset  class="fieldsetc">
                            <legend class="legendc">借支信息</legend>
                            <el-descriptions
                                class="margin-top"
                                :column="2"
                                :labelStyle="{'width':'120px','text-align':'center'}"
                                :contentStyle="{'text-align': 'center'}"
                                border
                            >
                                <el-descriptions-item :span="2">
                                    <template slot="label">
                                        <span>借支标题</span>
                                    </template>
                                    <span>{{petty.title}}</span>
                                </el-descriptions-item>
                                <el-descriptions-item :span="2" :contentStyle="{'text-align':'left','white-space':'pre-line'}">
                                    <template slot="label">
                                        <span>申请原由</span>
                                    </template>
                                    <span>{{petty.content}}</span>
                                </el-descriptions-item>
                                <el-descriptions-item>
                                    <template slot="label">
                                        <span>申请类型</span>
                                    </template>
                                    <span>{{all_type[petty.type]}}</span>
                                </el-descriptions-item>
                                <el-descriptions-item>
                                    <template slot="label">
                                        <span>申请金额</span>
                                    </template>
                                    <span>{{petty.money | fomatFloatMoney}}</span>
                                </el-descriptions-item>
                                <el-descriptions-item :contentStyle="{'text-align':'center','color':'#FF0000'}">
                                    <template slot="label">
                                        <span>已用金额</span>
                                    </template>
                                    <span>{{petty.use_money | fomatFloatMoney}}</span>
                                </el-descriptions-item>
                                <el-descriptions-item :contentStyle="{'text-align':'center','color':'#2828FF'}">
                                    <template slot="label">
                                        <span>剩余金额</span>
                                    </template>
                                    <span>{{petty.money - petty.use_money | fomatFloatMoney}}</span>
                                </el-descriptions-item>
                            </el-descriptions>
                        </fieldset>
                        <fieldset  class="fieldsetc bottomc">
                            <legend class="legendc">账户信息</legend>
                            <el-descriptions
                                class="margin-top"
                                :column="2"
                                :labelStyle="{'width':'120px','text-align':'center'}"
                                :contentStyle="{'text-align': 'center'}"
                                border
                            >
                                <el-descriptions-item>
                                    <template slot="label">
                                        <span>汇款方式</span>
                                    </template>
                                    <span>{{all_pay_way[petty.pay_way]}}</span>
                                </el-descriptions-item>
                                <el-descriptions-item>
                                    <template slot="label">
                                        <span>收款人</span>
                                    </template>
                                    <span>{{petty.account_name}}</span>
                                </el-descriptions-item>
                                <el-descriptions-item>
                                    <template slot="label">
                                        <span>开户行</span>
                                    </template>
                                    <span>{{petty.account_bank}}</span>
                                </el-descriptions-item>
                                <el-descriptions-item>
                                    <template slot="label">
                                        <span>银行卡号</span>
                                    </template>
                                    <span>{{petty.account_card}}</span>
                                </el-descriptions-item>
                            </el-descriptions>
                        </fieldset>
                        <common-upload-component
                            v-show="petty.other.length"
                            ref="upload"
                            :ffileList="petty.other"
                            upload_url="petty/upload"
                            :disabled="true"
                        ></common-upload-component>
                        <common-upload-component
                            v-show="AddFileDialogVisible"
                            ref="file_upload"
                            :ffileList="file_arr"
                            upload_url="petty/upload"
                            title="补充附件"
                        ></common-upload-component>
                    </div>
                </el-form>
            </div>
            <common-budget-component
                v-if="budget_count.all_quota"
                :budget_obj="budget_count"
            ></common-budget-component>
            <div slot="footer" class="dialog-footer">
                <div v-if="show_type===0">
                    <div v-if="AddFileDialogVisible === false">
                        <el-button
                            v-if="add_file_auth"
                            type="success"
                            plain
                            @click="add_file()"
                            >补充附件</el-button
                        >
                        <el-button
                            v-if="pay_auth"
                            type="primary"
                            round
                            @click="pettyPay('PettyEditForm')"
                            >汇款</el-button
                        >
                        <el-button
                            v-if="to_approval_auth"
                            type="success"
                            plain
                            @click="to_approval('PettyEditForm')"
                            >提交</el-button
                        >
                        <el-button
                            v-if="sel_approval_auth"
                            type="warning"
                            plain
                            @click="sel_approval()"
                            >查看审批</el-button
                        >
                        <el-button
                            v-if="withdraw_auth"
                            type="danger"
                            plain
                            @click="pettyWithdraw('PurchaseEditForm')"
                            >审批撤回</el-button
                        >
                        <el-button
                            v-if="edit_auth"
                            type="primary"
                            plain
                            @click="$emit('show_edit')"
                            >修改</el-button
                        >
                        <el-button
                            v-if="del_auth"
                            type="danger"
                            plain
                            @click="pettyDel('PettyEditForm')"
                            >删除</el-button
                        >
                        <el-button
                            plain
                            @click="closePettyDialog('PettyEditForm')"
                            >关闭</el-button
                        >
                    </div>
                    <div v-else>
                        <el-button
                            type="success"
                            plain
                            @click="submit_add_file()"
                            >确定</el-button
                        >
                        <el-button
                            plain
                            @click="exit_add_file()"
                            >取消</el-button
                        >
                    </div>
                </div>
                <div v-else-if="show_type===1">
                    <el-button
                        type="success"
                        plain
                        @click="submitInsert('PettyEditForm')"
                        >确定</el-button
                    >
                    <el-button
                        type="warning"
                        plain
                        @click="resetForm('PettyEditForm')"
                        >重置</el-button
                    >
                    <el-button
                        plain
                        @click="closePettyDialog('PettyEditForm')"
                        >关闭</el-button
                    >
                </div>
                <div v-else>
                    <el-button
                        type="success"
                        plain
                        @click="submitEdit('PettyEditForm')"
                        >确定修改</el-button
                    >
                    <el-button
                        plain
                        @click="closePettyDialog('PettyEditForm')"
                        >取消操作</el-button
                    >
                </div>
                <common-approval-dialog
                    :id="id"
                    :ApprovalDialogVisible="ApprovalDialogVisible"
                    :data="ApprovalData"
                    :current_examine_staff_id="petty.current_examine_staff_id"
                    :ApprovalAuth="ApprovalAuth"
                    :ApprovalRequest="PettyApprovalRequest"
                    @exitApprovalDialog="exitApprovalDialog"
                    @refresh="$emit('frefresh')"
                >
                </common-approval-dialog>
                <petty-print-component
                    :show_print="show_print"
                    :data="petty"
                    :ApprovalData="ApprovalData"
                    @exit_print="show_print = false"
                >
                </petty-print-component>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import CommonUploadComponent from '@/components/common/CommonUploadComponent'
import CommonApprovalDialog from '@/components/common/CommonApprovalDialog'
import PettyPrintComponent from './PettyPrintComponent'
import CommonBudgetComponent from '@/components/common/CommonBudgetComponent'

import { 
        petty_add_request,
        petty_del_request,
        petty_edit_request,
        petty_to_approval_request,
        petty_sel_approval_request,
        petty_approval_request,
        petty_pay_request,
        petty_withdraw_request,
        petty_add_file_request
    } from '@/network/finance/petty.js'
import { bank_card_list_request } from '@/network/list.js'
import { fomatFloat,thousandBitSeparator } from '@/assets/js/common.js'

export default {
    name: 'PettyEditComponent',
    data() {
        return {
            login_loading: false,
            ApprovalDialogVisible: false,
            petty: {
                title: '',
                content: '',
                department_id: [this.$store.state.user.enterprise_id,this.$store.state.user.department_id],
                type: '',
                staff_name: '',
                money: '',
                other: [],
                print: [],
                pay_way: '',
                with_bank_card: '',
                account_card: '',
                account_bank: '',
                account_name: ''
            },
            rules: {
                title: [
                    {
                        required: true,
                        message: '请输入标题',
                        trigger: 'blur',
                    },
                ],
                content: [
                    {
                        required: true,
                        message: '请输入内容',
                        trigger: 'blur',
                    },
                ],
                money: [
                    {
                        required: true,
                        message: '请输入预算金额',
                        trigger: 'blur',
                    },
                ],
                department_id: [
                    {
                        required: true,
                        message: '请选择申请部门',
                        trigger: 'blur',
                    },
                ],
            },
            Allcard: [],
            ApprovalData: [],
            PettyApprovalRequest:petty_approval_request,
            all_pay_way: ['公对公','公对私','私对私','私对公'],
            all_type: ['提前借支','储备额度','保证金'],
            show_print: false,
            AddFileDialogVisible: false,
            //补充附件
            file_arr: []
        }
    },
    computed: {
        dialogFormTitle() {
            if(this.show_type === 0) {
                return this.petty.name ? '备用金：' + this.petty.name : '备用金详情'
            } else if (this.show_type === 1) {
                return '添加备用金申请'
            } else {
                return '修改备用金申请'
            }
        },
    },
    methods: {
        closePettyDialog(formName) {
            this.petty = {
                title: '',
                content: '',
                department_id: [this.$store.state.user.enterprise_id,this.$store.state.user.department_id],
                type: '',
                staff_name: '',
                money: '',
                other: [],
                print: [],
                pay_way: '',
                with_bank_card: '',
                account_card: '',
                account_bank: '',
                account_name: ''
            }
            this.$emit('exitPettyDialog')
        },
        submitInsert(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return
                }
                this.pettyInsert(formName)
            })
        },
        pettyInsert(formName) {
            this.login_loading = true
            let d = this.petty
            d.department_id = d.department_id[d.department_id.length - 1]
            d.other = this.$refs.upload.fileList
            petty_add_request(d)
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.$message.success('添加成功!')
                        this.$emit('exitPettyDialog')
                        this.$emit('search')
                        this.$emit('details_row',s.result.id*1)
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.login_loading = false
                    this.$message.error(err)
                })
        },
        resetForm(formName) {
            this.petty = {
                title: '',
                content: '',
                department_id: [this.$store.state.user.enterprise_id,this.$store.state.user.department_id],
                type: '',
                staff_name: '',
                money: '',
                other: [],
                print: [],
                pay_way: '',
                with_bank_card: '',
                account_card: '',
                account_bank: '',
                account_name: ''
            }
        },
        submitEdit(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return
                }
                this.pettyEdit(formName)
            })
        },
        pettyEdit(formName) {
            this.login_loading = true
            this.petty.id = this.id
            this.petty.department_id = this.petty.department_id[this.petty.department_id.length - 1]
            this.petty.other = this.$refs.upload.fileList
            petty_edit_request(this.petty)
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.$message.success('修改成功!')
                        this.$emit('exitPettyDialog')
                        this.$emit('search')
                        this.$emit('details_row',this.petty.id)
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.login_loading = false
                    this.$message.error(err)
                })
        },
        pettyDel(formName) {
            this.$confirm(
                '是否确定删除？（一经删除，将无法再进行恢复，请谨慎操作！）',
                '温馨提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }
            )
                .then(() => {
                    petty_del_request(this.id)
                        .then((s) => {
                            if (s.status === 0) {
                                this.$message.success('删除成功!')
                                this.$emit('search')
                            } else {
                                this.$message.error(s.msg)
                            }
                        })
                        .catch((err) => {
                            this.$message.error(err)
                        })
                        .finally(() => this.closePettyDialog(formName))
                })
                .catch((err) => {})
        },
        pettyPay(formName) {
            this.$confirm(
                '是否确定已经汇款？（一经确认，将无法进行撤销，请谨慎操作！）',
                '温馨提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }
            )
                .then(() => {
                    petty_pay_request(this.id)
                        .then((s) => {
                            if (s.status === 0) {
                                this.$message.success('已确认汇款!')
                                this.$emit('search')
                            } else {
                                this.$message.error(s.msg)
                            }
                        })
                        .catch((err) => {
                            this.$message.error(err)
                        })
                        .finally(() => this.closePettyDialog(formName))
                })
                .catch((err) => {})
        },
        get_card_list() {
            bank_card_list_request()
                .then((s) => {
                    this.Allcard = s.result
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        to_approval(formName) {
            this.$prompt('请填写申请原因', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(({ value }) => {
                    this.login_loading = true
                    petty_to_approval_request({id:this.id,note:value})
                        .then((s) => {
                            this.login_loading = false
                            if (s.status === 0) {
                                    this.$message.success('提交成功!')
                                    this.$emit('search')
                            } else {
                                this.$message.error(s.msg)
                            }
                        })
                        .catch((err) => {
                            this.login_loading = false
                            this.$message.error(err)
                        })
                        .finally(() => this.closePettyDialog(formName))
                }).catch(()=>{});
        },
        exitApprovalDialog() {
            this.ApprovalDialogVisible = false
        },
        sel_approval() {
            this.login_loading = true
            petty_sel_approval_request(this.id)
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.ApprovalData = s.result
                        this.ApprovalDialogVisible = true
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.login_loading = false
                    this.$message.error(err)
                })
        },
        cardChange(e) {
            let account_name = ''
            let account_bank = ''
            let account_card = ''
            this.Allcard.forEach(v => {
                if(v.id === e) {
                    account_name = v.user_name
                    account_bank = v.bank
                    account_card = v.card
                }
            });

            this.petty.account_name = account_name
            this.petty.account_bank = account_bank
            this.petty.account_card = account_card
        },
        pettyWithdraw() {
            this.$confirm(
                '是否确定撤回？（请谨慎操作）',
                '温馨提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }
            )
                .then(() => {
                    this.login_loading = true
                    petty_withdraw_request({id:this.id})
                        .then((s) => {
                            this.login_loading = false
                            if (s.status === 0) {
                                this.$message.success('已撤回!')
                                this.$emit('frefresh')
                                this.$emit('search')
                            } else {
                                this.$message.error(s.msg)
                            }
                        })
                        .catch((err) => {
                            this.login_loading = false
                            this.$message.error(err)
                        })
                })
                .catch((err) => {})
        },
        clk_print() {
            this.login_loading = true
            petty_sel_approval_request(this.id)
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.ApprovalData = s.result
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.login_loading = false
                    this.$message.error(err)
                })
            this.show_print = true
        },
        add_file() {
            this.AddFileDialogVisible = true
        },
        exit_add_file() {
            this.AddFileDialogVisible = false
            this.file_arr = []
        },
        submit_add_file() {
            let data = {}
            this.file_arr = this.$refs.file_upload.fileList
            data['id'] = this.id
            data['file'] = this.file_arr
            petty_add_file_request(data)
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.$message.success('补充附件成功!')
                        this.$emit('frefresh')
                        this.AddFileDialogVisible = false
                        this.file_arr = []
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.login_loading = false
                    this.$message.error(err)
                })
        }
    },
    filters: {
        fomatFloatMoney(data) {
            return data ? thousandBitSeparator(fomatFloat(data)) + '元' : (data===0 ? '0.00元' : '')
        }
    },
    props: {
        dialogFormVisible: Boolean,
        id: {
            type: Number,
            default() {
                return 0
            },
        },
        petty_details_data: {
            type: Object,
            default() {
                return {}
            },
        },
        enterprise_department: {
            type: Array,
            default() {
                return []
            },
        },
        show_type: {
            type:Number,
            default() {
                return 0
            },
        },
        edit_auth: {
            type:Boolean,
            default() {
                return false
            },
        },
        del_auth: {
            type:Boolean,
            default() {
                return false
            },
        },
        add_file_auth: {
            type:Boolean,
            default() {
                return false
            }
        },
        to_approval_auth: {
            type:Boolean,
            default() {
                return false
            },
        },
        sel_approval_auth: {
            type:Boolean,
            default() {
                return false
            },
        },
        ApprovalAuth: {
            type:Boolean,
            default() {
                return false
            },
        },
        pay_auth: {
            type:Boolean,
            default() {
                return false
            },
        },
        withdraw_auth: {
            type:Boolean,
            default() {
                return false
            }
        },
        print_auth: String,
        budget_count: {
            type: Object,
            default() {
                return {
                    all_quota: 0,
                    use_quota: 0,
                    per_quota: 0,
                    entertain_quota: 0,
                    travel_quota: 0,
                    other_quota: 0
                }
            }
        }
    },
    created() {
        this.get_card_list()
    },
    destoryed() {},
    mounted() {},
    updated() {},
    components: {
        CommonUploadComponent,
        CommonApprovalDialog,
        PettyPrintComponent,
        CommonBudgetComponent
    },
    watch: {
        petty_details_data(newVal) {
            this.petty = newVal
            this.petty.id = this.id
        },
    },
}
</script>

<style lang='less'>
.bottomc {
    margin-bottom: 10px;
}
.with_bank_cardc {
    width: 100%;
}
.pay_wayc {
    width: 100%;
}
.typec {
    width: 100%;
}
.input_number {
    width: 100%;
}
</style>